import { buttonStyles, type models } from '../models';
import { Modal } from './modal';

export abstract class ToastModal extends Modal {
  constructor(rewardMessage: models.RewardMessage) {
    super(rewardMessage);
  }

  /**
   * render modal
   */
  public abstract render(rewardMessage: models.RewardMessage): void;

  /**
   * render close button
   */
  protected renderCloseButton(box: HTMLDivElement) {
    const closeButton: HTMLButtonElement = document.createElement('button');
    closeButton.className = 'toast-close-button';
    box.appendChild(closeButton);

    const iconDiv: HTMLDivElement = document.createElement('div');
    iconDiv.style.height = '18px';
    iconDiv.innerHTML = this.closeSvgIconSmall;

    closeButton.appendChild(iconDiv);

    const closeWraper = () => this.closeModal();
    closeButton.addEventListener('click', closeWraper);

    this.addButton(closeButton, closeWraper);
  }

  /**
   * render buttons
   */
  protected renderButtons(
    rewardMessage: models.RewardMessage,
    box: HTMLDivElement
  ) {
    const buttonsDiv: HTMLDivElement = document.createElement('div');
    box.appendChild(buttonsDiv);
    buttonsDiv.className = 'toast-buttons';

    rewardMessage.RewardButtons?.forEach(rewardButton => {
      const btn = this.buttonsAsLinks
        ? (document.createElement('a') as HTMLAnchorElement)
        : (document.createElement('button') as HTMLButtonElement);
      const styleVale: string = (
        !!rewardButton?.Style ? buttonStyles[rewardButton?.Style] : ''
      ).toLocaleLowerCase();
      btn.className = `modal-confirm-button toast-confirm-button modal-button-${styleVale}`;
      btn.textContent = rewardButton.Text as string;
      const clickWraper = () =>
        this.handleClick(rewardButton.Type, rewardButton.Parameters);
      if (!!rewardButton.Type && !this.buttonsAsLinks) {
        btn.addEventListener('click', clickWraper);
      }

      if (this.buttonsAsLinks && btn instanceof HTMLAnchorElement) {
        this._addHrefToLink(rewardButton, btn);
      }

      buttonsDiv.appendChild(btn);
      if (!this.buttonsAsLinks && btn instanceof HTMLButtonElement) {
        this.addButton(btn, clickWraper);
      }
    });
  }
}
